import Vue from 'vue'
import VueRouter from 'vue-router'
import GSA from '../views/GSA.vue'
import IsolaterGsaCreator from '../views/IsolatedGsaCreator'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/gsa'
  },
  {
    path: '/gsa/new',
    name: 'Добавление GSA',
    component: IsolaterGsaCreator,
    children: [
      {
        path: '',
        name: 'Редактор',
        component: () => import('@/views/newGSA.vue')
      }
    ]
  },
  {
    path: '/gsa',
    name: 'Агенты',
    component: GSA,
    children: [
      {
        name: "Список",
        path: '',
        component: () => import('@/views/GsaList.vue')
      },
      {
        path: ':gsa_id',
        name: "Редактирование",
        component: () => import('@/views/EditGsa.vue')
      }
      
    ]
  }
]

const router = new VueRouter({
  mode:'history',
  routes
})

export default router
